export default __webpack_public_path__ + "static/IBMPlexMono-Medium-92630f6450efcebeffb0fb91b7c6d327.ttf";